var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-container',{staticClass:"group-page",class:{
		'group-page--alert-view': _vm.alertView,
	}},[_vm._t("default"),(_vm.canDeclineInvitation)?_c('decline-group-invitation',{staticClass:"group-decline",attrs:{"group-id":_vm.groupId}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }